import React, { useState, useEffect } from 'react';
import { animated, useTrail } from '@react-spring/web';
import Box from '@mui/material/Box';

const LoadingBar = () => {
  const [ loading, setLoading ] = useState(true);
  const trail = useTrail( 10 , {
    from: { opacity: 0 },
    to : { opacity: 1 },
    leave: { opacity: 0 },
    trail: 1000, 
    config: { duration: 800 },
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div id="loadingScreen" style={{
      position:'fixed',
      top:0,
      left:0,
      height:'100vh',
      width:'100vw',
      zIndex:'4',
      background: '#111111',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }} 
    className={loading ? 'true' : 'false'}>
      <div className='wrapper' style={{textAlign: 'center'}}>
        <img
          src={process.env.PUBLIC_URL + '/closed.png'}
          alt="Delta Power Group Logo"
          style={{
            width: '250px',
            height: 'auto',
            marginBottom: 32
          }}
        />
        <div
          style={{
            width: '100%',
            height: '30px',
            border: '2px solid #333',
            overflow: 'hidden',
            display: 'flex',
            background: '#181818',
            marginTop: 32
          }}
        >
          {trail.map((props, index) => (
            <animated.div
              key={index}
              style={{
                ...props,
                background: '#ffffff',
                borderRight: '2px solid #333',
                width: '15%',
                marginRight: '5px',
                textAlign: 'center',
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LoadingBar;


